import { EnrollmentStatus } from '@zorro/clients';

// Statuses from "Carrier application sent" onward, where the payments tab and
// payment status management are available.
export const paymentsTabEnabledEnrollmentStatuses = new Set([
  EnrollmentStatus.ENROLLMENT_IN_PROCESS,
  EnrollmentStatus.ENROLLMENT_CONFIRMED,
  EnrollmentStatus.ACTIVE_COVERAGE,
  EnrollmentStatus.COVERAGE_ENDED,
]);
